import {CONV_STORAGE, kinoParticipants, onStage, permissions, spacesView, Video} from "../libs/roomnew";

export default class Volume{
    constructor(defaultVolume=0.05){
        this.masterVolume=defaultVolume;
        this.masterMuted=false;
        this.masterVolumeButton=$('#audioMasterVolume');
        this.chatterButton = $("#chatterBtnId");
        // this.masterChatterButton=$("#toolbox-chatter-button");
        // this.masterChatterToggle=$("#background-chatter-toolbox");
        // this.masterChatterIcon=$("#toolbox-chatter-icon");
        this.masterVolumeSlider=$("");
        this.muteVolumeOverwrite=false;
        this.stateChangedWhileMuted=false;
        this.lastMasterVolume=0.05;
        this.lastParticipantVolume={};

        this.events();
    };

    events(){}

    initMasterVolume () {
        let v = this;

        if(Video.lockMasterVolume.isLocked()){
            v.addDisabledMasterVolume();
        }else{
            v.addEnabledMasterVolume();
        }
        // this.masterChatterButton.on('click',(e)=>{
        //     e.preventDefault();
        //     if(this.masterVolume == 0){
        //         this.setChatterOn();
        //     }else{
        //         this.setChatterOff();
        //     }
        // });
    };

    setChatterOff(){
        this.changeMasterVolume(0);
    }

    setChatterOn(){
        this.changeMasterVolume(0.05);
        // this.setChatterOnUI();
    }

    setChatterOffUI(){
        this.masterVolumeButton.html(Video.volumeIconMuted);
        // this.masterChatterButton.find(".kino-slider").html(Video.volumeIconMuted);
        // this.masterChatterToggle.prop('checked',false);
        this.chatterButton.attr('data-original-title',"Spaces chatter is off");
    };

    setChatterOnUI(){
        this.masterVolumeButton.html(Video.volumeIcon);
        // this.masterChatterButton.find(".kino-slider").html(Video.volumeIcon);
        // this.masterChatterToggle.prop('checked',true);
        this.chatterButton.attr('data-original-title',"Spaces chatter is on");

    };


    addEnabledMasterVolume(){
        var v = this;
        let volumePopupTimer = 0;
        let sliderStep = 0.01;
        let prevVolume;

        this.chatterButton.off().on('click', () => {
            console.log("Chatter button click")
            this.toggleChatter();
        });
        this.updateMasterVolumeIcon(v.masterVolume);
    }

    toggleChatter(){
        if(Video.lockMasterVolume.isLocked()){return}
        console.warn("Last saved master volume values is",this.lastMasterVolume);
        console.warn('Is master volume muted ', this.masterMuted);
        if (this.masterMuted) {
            this.unMuteChatter();
        } else {
            this.muteChatter();
        }
    }

    muteChatter(){
        this.masterMuted = true;
        this.chatterButton.addClass('muted');
        console.trace("MUTING CHATTER")
        this.changeMasterVolume(0);
        this.stateChangedWhileMuted=false;
    }

    addDisabledMasterVolume(){
        if(!permissions.isWorkspace || permissions.shouldLockChatter()){
            this.chatterButton.off()
            .attr('data-toggle',"tooltip")
            .attr('data-original-title','Spaces chatter is locked');
            this.chatterButton.tooltip('show');
            this.masterVolumeButton.html(Video.volumeIconMuted);
            // $('#masterAudioContainer').find('.action-drop-up').remove();
        }
        // $('#masterAudioContainer .tool-box-description').removeClass('toolbox-label-master')
    }
    unMuteChatter(){
        console.trace("UN-MUTING CHATTER")
        this.masterMuted = false;
        this.muteVolumeOverwrite=false;
        this.changeMasterVolume(0.05,!this.stateChangedWhileMuted);
        this.stateChangedWhileMuted=false;
    };

    inMySpaceUsersVolume(defaultVolume=1){
        kinoParticipants.inMySpace().forEach(pid=>{
            try {
                kinoParticipants.get(pid).setVolume(defaultVolume,true);
            } catch (error) { console.error("[Kino Error] [Volume]", error); }
        })
    };

    changeMasterVolume (volume,isUnmute=false) {
            console.trace(`Changing master volume to ${volume},isUnmute ${isUnmute}`)
            this.updateMasterVolumeIcon(volume);
            this.masterVolume=volume;
            onStage.volumeMutedByOnStage=false;
            if(volume==0){
                this.masterMuted=true
            }else{
                this.masterMuted=false;
            }

            //set lobby volume if I am in a space
            if(CONV_STORAGE.myConversation){
                if(isUnmute) spacesView.unMute(); else spacesView.setVolume(volume,true);
            }
            Object.values(CONV_STORAGE.conversations).forEach(space=>{
                try {
                    if(space.id != CONV_STORAGE.myConversation){
                        if(isUnmute) space.unMute(); else space.setVolume(volume,true);
                    }
                } catch (error) {
                    console.error("Error setting space volumes",error)
                }
            })
    };

    resetSpacesVolumes(mySpaceId){
        const resetVolume = this.masterMuted ? 0 : 0.05;

        mySpaceId == 'lobby' || spacesView.setVolume(resetVolume,true);

        Object.values(CONV_STORAGE.conversations).forEach(space=>{
            try {
                if(space.id != mySpaceId){
                    space.setVolume(resetVolume,true);
                }
            } catch (error) {
                console.error("Error setting space volumes",error)
            }
        })
    }

    updateMasterVolumeIcon(volume){
        if(volume > 0){
            this.masterMuted=false;
            this.lastMasterVolume=parseFloat(volume);
            this.masterVolumeButton.html(Video.volumeIcon);
            Video.lockMasterVolume.isLocked() || this.chatterButton.removeClass('muted').attr('data-original-title','Set spaces chatter off');
            this.chatterButton.find('#header-buttons-title').html("CHATTER: ON")
        }else{
            this.masterMuted = true;
            this.masterVolumeButton.html(Video.volumeIconMuted);
            Video.lockMasterVolume.isLocked() || this.chatterButton.addClass('muted').attr('data-original-title','Set spaces chatter on');
            this.chatterButton.find('#header-buttons-title').html("CHATTER: OFF")
        }
    }

    updateParticipantTileVolume(volume ,id){
        if (volume == 0) {
            if (Video.videos[id].muteIcon !== undefined) {
                // volumeManager.stateChangedWhileMuted = false;
                Video.videos[id].muteIcon.html(Video.volumeIconMuted);
                Video.videos[id].muteIcon.addClass('muted');
                Video.videos[id].isMuted = true;
                // Video.videos[id].muteIcon.attr('title', 'Unmute');
                Video.videos[id].muteIcon.attr('data-original-title', 'Unmute');
            }
        } else {
            if (Video.videos[id].muteIcon !== undefined) {
                if(volume > 0 && volume <= 0.50){
                    Video.videos[id].muteIcon.html(Video.volumeHalfIcon);
                }else{
                    Video.videos[id].muteIcon.html(Video.volumeIcon);
                }

                Video.videos[id].muteIcon.removeClass('muted');
                Video.videos[id].isMuted = false;
                // Video.videos[id].muteIcon.attr('title', 'Mute');
                Video.videos[id].muteIcon.attr('data-original-title', 'Mute');
            }
        }
    }

    changeParticipantVolume(pid,volume,skipAnnouning=false){
        try {
            kinoParticipants.get(pid).setVolume(volume,true,skipAnnouning);
        } catch (error) { console.error("[Kino Error] [Volume]", error); }
    };
    unMuteParticipant(pid){
        try {
            Video.videos[pid].isMuted = false;
            if(this.lastParticipantVolume[pid] && !this.stateChangedWhileMuted){
                this.changeParticipantVolume(pid,this.lastParticipantVolume[pid]);
            }else{
                let p = kinoParticipants.get(pid);
                if(p){
                    if(p.inMyLobby() && !kinoParticipants.isInMySpace(pid)){
                        //for participants within lobby
                        let vol=1;
                        if(this.lastParticipantVolume[pid]){
                            vol=this.lastParticipantVolume[pid];
                        }
                        this.changeParticipantVolume(pid,this.muteVolumeOverwrite ? 1 : vol);
                    }else if (kinoParticipants.isInMySpace(pid)){
                        //for participants within your space
                        this.changeParticipantVolume(pid,this.lastParticipantVolume[pid]);
                    }else if(!p.inMyLobby() && !kinoParticipants.isInMySpace(pid)){
                        //for participants outside your space
                        this.changeParticipantVolume(pid,this.masterVolume == 0 ? 0.05 : this.masterVolume);
                    }
                }
            }
        } catch (error) {
            console.error("Unmute participant error",error)
        }
    };
    setSpaceJoinedVolume(pid){
        let p = kinoParticipants.get(pid);
        if(p){
            p.setVolume(1,true,false);
        }
    };

    setSpaceLeftVolume(pid){
        let p = kinoParticipants.get(pid);
        if(p){
            console.log(`Setting space left volume for participant ${p.getName()}, volume overwrite `,this.muteVolumeOverwrite)
            if(p.inMyLobby()){
                if(this.muteVolumeOverwrite && this.masterMuted){
                    p.setVolume(1,true,false);
                }else{
                    if(this.masterMuted){
                        this.lastParticipantVolume[p.id]=1;
                    }
                    p.setVolume(1,true,false);
                }
            }else{
                const space = CONV_STORAGE.getSpace(p.getSpaceId());
                const spaceVolume = space ? space.volumeSlider.val() : spacesView.volumeSlider.val();
                p.setVolume(spaceVolume,true,true);
            }
        }
    };

    onUnfocusVolume(unFocusedId){
        try {
            let p = kinoParticipants.get(unFocusedId);
            if(Object.keys(Video.focused).length==0){
                if(!this.masterMuted){
                    this.changeMasterVolume(1,0.05);
                }else{
                    this.stateChangedWhileMuted=true;
                    if(this.muteVolumeOverwrite && this.masterMuted){
                        p.setVolume(1,true,true);
                    }else{
                        if(this.masterMuted){
                            this.lastParticipantVolume[p.id]=1;
                        }
                        p.setVolume(1,true,true);
                    }
                }
            }else{
               if(p){
                    if(p.inMyLobby()){
                        if(this.muteVolumeOverwrite && this.masterMuted){
                            p.setVolume(1,true,true)
                        }else{
                            if(this.masterMuted){
                                this.lastParticipantVolume[p.id]=1;
                            }
                            p.setVolume(1,true,true);
                        }

                    }else{
                        p.setVolume(this.masterVolume,true,true);
                    }
                }
            }

        } catch (error) { console.error("[Kino Error] [Volume]", error); }
    };
    joinedOtherSpaceVolume(pid){
        let p = kinoParticipants.get(pid);
        if(p){
            const space = CONV_STORAGE.getSpace(p.getSpaceId());
            const spaceVolume = space ? space.volumeSlider.val() : 0.05;
            p.setVolume(spaceVolume,true,true);
            // if(!CONV_STORAGE.myConversation && Object.keys(Video.focused).length==0){
            //     if(this.masterVolume==1){
            //         p.setVolume(0.05,true,false);
            //     }else{
            //         if(this.masterMuted){
            //             this.lastParticipantVolume[pid]=0.05;
            //         }
            //         p.setVolume(this.masterVolume,true,true);
            //     }
            // }else{
            //     if(this.masterMuted){
            //         this.lastParticipantVolume[pid]=0.05;
            //     }
            //     p.setVolume(this.masterVolume,true,true);
            // }
        }
    }
    setVolumeOnJoin(pid){
        try {
            let p = kinoParticipants.get(pid);
            if(p){
                if (Video.initialVolume[pid] && !kinoParticipants.isInMySpace(pid)){
                    p.setVolume(Video.initialVolume[pid],true,true);
                    delete Video.initialVolume[pid];
                    return;
                }
                delete Video.initialVolume[pid];
                if(p.inMyLobby()){
                    if(this.masterMuted && this.muteVolumeOverwrite){
                        p.setVolume(1,true,true);
                    }else{
                        if(kinoParticipants.isInMySpace(p.id) || Video.focused[p.id]){
                            p.setVolume(1,true,true);
                        }else{
                            p.setVolume(1,true,true);
                        }

                    }
                }else{
                    if(CONV_STORAGE.myConversation){
                        p.setVolume(this.masterVolume,true,true);
                    }else{
                        if(p.getSpaceId() && this.masterVolume==1){
                            p.setVolume(0.05,true,true);
                        }else{
                            p.setVolume(this.masterVolume,true,true);
                        }
                    }
                }
            }
        } catch (error) { console.error("[Kino Error] [Volume]", error); }
    };
    updateMasterVolumeSlider(){
        try {
            let volume=this.masterVolumeSlider.val();
            let formated=Math.round(volume * 100).toFixed(0);
            $(".masterAudioVal").html(formated+"%").attr('value', volume);

        } catch (error) { console.error("[Kino Error] [Volume]", error); }

    };


    disableChatterButton(){
        this.masterVolumeButton.addClass("toggle-disabled");
        $("#masterAudioContainer").attr('data-toggle','tooltip')
        .attr('data-placement','top')
        .attr('title','Chatter is disabled when Stage View is active.')
        .attr('data-original-title','Chatter is disabled when Stage View is active.').tooltip()
        this.masterVolumeButton.prop("disabled",true);
    };

    enableChatterButton(){
        this.masterVolumeButton.removeClass("toggle-disabled");
        $("#masterAudioContainer").removeAttr('data-toggle data-placement data-original-title title');
        this.masterVolumeButton.prop("disabled",false);
    };
};
